import { UserCommonService } from './../../services/user-common.service';
import { CommonBindingDataService } from './../../services/common-binding-data.service';
import { UntypedFormGroup, FormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html'
})
export class SetPasswordComponent implements OnInit {
  @Output() onSetPasswordPopClose: EventEmitter<any> = new EventEmitter();
  @Input() otpId;

  isSubmitting = false;
  setPasswordForm = new UntypedFormGroup({
    newPassword: new UntypedFormControl(),
    newConfirmPassword: new UntypedFormControl()
  });

  constructor(
    private formBuilder: FormBuilder,
    private signOutService: UserCommonService,
    private commonService: CommonBindingDataService,
    private uiService: UiService
  ) { }

  ngOnInit() {
    this.setPasswordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.minLength(5),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS)]],
      newConfirmPassword: ['', [Validators.required, Validators.minLength(5),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS)]]
    });
  }

  passwordNotMatched(): boolean {
    if (this.setPasswordForm.controls.newPassword.value !== this.setPasswordForm.controls.newConfirmPassword.value) {
      this.uiService.showMessage(
        this.commonService.getLabel('error_new_confirm_password_not_match'),
        AppSettings.MESSAGE_TYPE.ERROR
      );
      return false;
    }
    return true;
  }

  requestData() {
    return {
      otpId: this.otpId,
      password: this.setPasswordForm.controls.newPassword.value,
    };
  }

  doChangePassword() {
    if (this.isSubmitting || this.setPasswordForm.invalid) {
      this.setPasswordForm.markAllAsTouched();
      return;
    }
    if (!this.passwordNotMatched()) {
      return;
    }

    this.isSubmitting = true;
    this.signOutService.setPassword(JSON.stringify(this.requestData())).subscribe(results => {
      this.isSubmitting = false;
      if (results.general !== null && results.general !== undefined) {
        const message = results.general[0]?.message;
        if (message) {
          this.uiService.showMessage(message, AppSettings.MESSAGE_TYPE.SUCCESS);
        }
        setTimeout(() => {
          this.setPasswordForm.reset();
          this.onSetPasswordPopClose.emit(false);
        }, 1500);
      }
    }, (error) => {
      this.isSubmitting = false;
      this.showErrorToast(error);
    });
  }

  onCancel() {
    if (this.isSubmitting) {
      return;
    }
    this.setPasswordForm.reset();
    this.onSetPasswordPopClose.emit(false);
  }

  private showErrorToast(error) {
    const message = this.getApiErrorMessage(error);
    if (message) {
      this.uiService.showMessage(message, AppSettings.MESSAGE_TYPE.ERROR);
    }
  }

  private getApiErrorMessage(error): string {
    if (!error) {
      return '';
    }
    for (const key of Object.keys(error)) {
      if (Array.isArray(error[key]) && error[key][0]?.message) {
        return error[key][0].message;
      }
    }
    return '';
  }
}
